/* eslint-disable no-new no-alert, no-console, no-unused-vars, no-undef */
import Vue from "vue";

function checkUserAuthorization(context, rolesAuthorization, redirect) {
  if (
    isArray(rolesAuthorization) &&
    context.state.userInfo != null &&
    isArray(context.state.userInfo.roles)
  ) {
    redirect = { name: "NotAuthorized" };

    for (var i = 0; i < context.state.userInfo.roles.length; i++) {
      var role = context.state.userInfo.roles[i];

      if (rolesAuthorization.includes(role.toLowerCase())) {
        redirect = {};
      }
    }
  }

  return redirect;
}

function setSeasons(context, lang) {
  var uri =
    "inventoryreception/GetSeasons?inEnglish=" +
    (lang === "en").toString().toLowerCase() +
    "&isIntranet=true";

  return Vue.http
    .get(uri, {
      headers: { Authorization: "Bearer " + context.state.token },
      responseType: "json"
    })
    .then(
      response => {
        if (response.bodyText !== "") {
          context.commit("ADD_SEASONS", response.body);
          return;
        }

        context.commit("CLEAR_SEASONS");
      },
      () => {
        context.commit("CLEAR_SEASONS");
      }
    );
}

const identityVuexModule = {
  state: {
    userInfo: null,
    token: "",
    seasons: []
  },
  mutations: {
    ADD_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    ADD_TOKEN(state, token) {
      state.token = token;
      Vue.cookie.set("at", token, { expires: 90 });
    },
    ADD_SEASONS(state, seasons) {
      state.seasons = seasons.slice(0);
      state.seasons.reverse();
    },
    CLEAR_USERINFO(state) {
      state.userInfo = null;
    },
    CLEAR_TOKEN(state) {
      state.token = "";
      Vue.cookie.delete("at");
    },
    CLEAR_SEASONS(state) {
      state.seasons = [];
    },
    CLEAR_ALL(state) {
      state.token = "";
      state.userInfo = null;
      state.season = [];
      Vue.cookie.delete("at");
    }
  },
  actions: {
    getToken(context, payload) {
      return Vue.http
        .post(
          "auth/GetToken",
          {},
          {
            headers: { Authorization: "Basic " + payload.auth },
            responseType: "json"
          }
        )
        .then(
          response => {
            if (response.bodyText === "") {
              return { error: true, message: "" };
            }

            var token = response.body.value;
            context.commit("ADD_TOKEN", token);
            return { error: false, message: "" };
          },
          response => {
            context.commit("CLEAR_TOKEN");
            return { error: true, message: response.statusText };
          }
        );
    },
    setToken(context, token) {
      context.commit({
        type: "ADD_TOKEN",
        token: token
      });
    },
    clearToken(context) {
      context.commit("CLEAR_TOKEN");
    },
    clearAll(context) {
      context.commit("CLEAR_ALL");
    },
    valideToken(context, payload) {
      var token = Vue.cookie.get("at");
      var to = payload.to;
      var result = to.path === "/" ? {} : { name: "Login" };

      if (token === "" || token == null) {
        return result;
      }

      if (context.state.token === "") {
        context.commit("ADD_TOKEN", token);
      }

      return Vue.http
        .get("auth/GetTokenValidation", {
          headers: { Authorization: "Bearer " + token },
          responseType: "json"
        })
        .then(
          response => {
            if (response.bodyText === "") {
              context.commit("CLEAR_TOKEN");
              return result;
            }
            var value = response.body.value;

            result = to.path === "/" ? { name: "Home" } : {};

            var getUserInfo = false;
            var rolesAuthorization = to.meta.authorizeRole;

            if (value !== context.state.token) {
              context.commit("ADD_TOKEN", value);
              getUserInfo = true;
            }

            if (!result.getUserInfo && context.state.userInfo == null) {
              getUserInfo = true;
            }

            if (context.state.seasons.length === 0) {
              setSeasons(context, payload.lang);
            }

            if (getUserInfo) {
              return Vue.http
                .get("identity/GetUserInfo", {
                  headers: { Authorization: "Bearer " + context.state.token },
                  responseType: "json"
                })
                .then(
                  response => {
                    if (response.bodyText !== "") {
                      context.commit("ADD_USERINFO", response.body);
                      result = checkUserAuthorization(
                        context,
                        rolesAuthorization,
                        result
                      );
                      return result;
                    }

                    context.commit("CLEAR_USERINFO");
                    return to.path === "/" ? {} : { name: "Login" };
                  },
                  () => {
                    context.commit("CLEAR_USERINFO");
                    return to.path === "/" ? {} : { name: "Login" };
                  }
                );
            }

            result = checkUserAuthorization(
              context,
              rolesAuthorization,
              result
            );

            return result;
          },
          () => {
            context.commit("CLEAR_ALL");

            return result;
          }
        );
    },
    setSeasons(context, payload) {
      return setSeasons(context, payload.lang);
    }
  }
};

// check if the given object is an array
function isArray(obj) {
  return !!obj && Array === obj.constructor;
}

export default identityVuexModule;



// WEBPACK FOOTER //
// ./src/identity/vuex-identity-store.js